//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { focus } from '~/helpers/directives';
import SfInput from './SfInput.vue';

export default {
  name: 'SfSearchBar',
  components: { SfInput },
  directives: {
    focus,
  },
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: null,
    },
    icon: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        'keyup.esc': () => this.$emit('input', ''),
        blur: () => this.$emit('blur'),
        'click:icon': () => this.$emit('click:icon', this.value),
      };
    },
  },
};
